module.exports = __webpack_public_path__ + "static/media/apple-iphone12pro-pacificblue-portrait.0bbe36ea.png";